import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${colors.white};
  padding: 0px 10px 0px 10px;
`;

type ScrollToBottomButtonProps = {
  visible: boolean;
};

export const ScrollToBottomButton = lib.styled.button<
  ScrollToBottomButtonProps
>`
  position: absolute;
  bottom: 16px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${colors.white};
  border: 1px solid ${colors.lightGray06};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${colors.darkGray13};
  transition: opacity 180ms ease, transform 180ms ease, background 150ms ease;
  opacity: ${({ visible }: ScrollToBottomButtonProps) => (visible ? 1 : 0)};
  transform: translateY(
    ${({ visible }: ScrollToBottomButtonProps) => (visible ? '0' : '8px')}
  );
  pointer-events: ${({ visible }: ScrollToBottomButtonProps) =>
    visible ? 'auto' : 'none'};
  z-index: 2;

  &:hover {
    background: ${colors.lightGray18};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Section = lib.styled.div`
  background: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
  padding-bottom: 20px;

  span {
    border-radius: 20px;
    background-color: ${colors.darkGray11};
    padding: 5px 7px 5px 7px;
    font-size: 12px;
    color: ${colors.white};
  }

  .line {
    height: 1px;
    background-color: ${colors.lightGray06};
    flex: 1;
  }
`;

export const Empty = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  margin-top: -50px;

  svg {
    width: 180px;
    height: 180px;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    color: ${colors.darkGray13};
  }

  .sub-title {
    font-size: 14px;
    text-align: center;
    color: ${colors.darkGray13};
  }
`;

export const SearchFoundResults = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;

  span {
    font-size: 14px;
    color: ${colors.darkGray13};
  }
`;
